class VerdictSummaryDetailsController {
    constructor($routeParams, $browser, $window, $location, $uibModal, moment, UserDetails, UserDetailsApi, toastr, ReportUtilityServiceApi, ReportServiceApi, SettingsService) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.window.document.title = 'Verdict Summary Details';
            this.data = {
                testerSimSuites: [],
                sims: [],
                suites: [],
                responseData: undefined
            };
            let hide = true;
            let columnDefs = [
                { headerName: 'UserId', field: 'UserId', width: 70, hide: hide },
                {
                    headerName: 'SimId',
                    field: 'SimId',
                    width: 70,
                    filter: 'number',
                    hide: hide
                },
                {
                    headerName: 'Simulator',
                    field: 'SimName',
                    width: 120,
                    minWidth: 105,
                    sort: 'asc'
                },
                {
                    headerName: 'SuiteId',
                    field: 'TestSuiteId',
                    width: 70,
                    filter: 'number',
                    hide: hide
                },
                {
                    headerName: 'Test Suite',
                    field: 'TestSuiteName',
                    width: 120,
                    minWidth: 110,
                    sort: 'asc'
                },
                {
                    headerName: 'TestId',
                    field: 'TestId',
                    width: 70,
                    filter: 'number',
                    hide: hide
                },
                {
                    headerName: 'Test Case',
                    field: 'TestCaseName',
                    width: 120,
                    minWidth: 110,
                    sort: 'asc'
                },
                {
                    headerName: 'UserId',
                    field: 'UserId',
                    width: 70,
                    filter: 'number',
                    hide: hide
                },
                {
                    headerName: 'User',
                    field: 'Description',
                    width: 120,
                    minWidth: 110,
                    hide: true
                },
                {
                    headerName: 'Timestamp (UTC)',
                    field: 'Timestamp',
                    width: 155,
                    minWidth: 155,
                    cellRenderer: this.caseCellRenderer
                },
                { headerName: 'Passed', field: 'Passed', width: 70 },
                {
                    headerName: 'Reason',
                    field: 'Reasons',
                    width: 440,
                    minWidth: 130
                }
            ];
            this.gridOptions = {
                defaultColDef: {
                    resizable: true,
                    sortable: true,
                    filter: true
                },
                columnDefs: columnDefs,
                rowSelection: 'single',
                suppressMovableColumns: true, // Added because of ag-grid bug see https://github.com/ceolter/ag-grid/issues/965#issuecomment-225857509
                // Filtering
                onModelUpdated: this.onModelUpdated,
                angularCompileRows: true,
                onGridReady: this.autoSizeAll
            };
            // Get the params passed from parent page
            let params = this.resolve;
            this.state = {
                linkFromName: true,
                userDetails: params.user,
                reportRequest: {
                    UserId: 0,
                    SimId: 0,
                    TestSuiteId: 0,
                    TestId: 0,
                    Passed: 0,
                    Suspended: 0
                },
                gridOptions: {},
                DateFormats: {},
                activeTesters: [],
                showFilters: false,
                selectedSim: params.selectedItems.selectedSim,
                selectedSuite: params.selectedItems.selectedSuite,
                selectedTest: params.selectedItems.selectedTest,
                selectedPassed: params.selectedItems.selectedPassed,
                selectedTester: params.selectedItems.selectedTester,
                selectedSuspended: params.selectedItems.selectedSuspended
            };
            this.SettingsService.getSettings().then((response) => {
                let appSettings = response.data;
                this.state.DateFormats = {
                    DateTimeFormat: appSettings.DateTimeFormat,
                    DateFormat: appSettings.DateFormat,
                    TimeFormat: appSettings.TimeFormat
                };
            }).then(() => {
                return this.getUserDetails();
            });
        };
        this.getUserDetails = () => {
            return this.UserDetailsApi.get().then((response) => {
                this.state.userDetails = response.data; // setup our user details
                this.getVerdictDetails(); // this.state.selectedTester
                this.gridOptions.api.sizeColumnsToFit();
                this.autoSizeAll();
            }, () => {
                this.toastr.error('Please make sure that you are logged in to OTS UTP!');
                this.window.location.href =
                    this.browser.baseHref() + 'account/login';
                return;
            });
        };
        this.caseCellRenderer = (row) => {
            let time = [
                '<span>',
                this.moment(new Date(row.data.Timestamp))
                    .utc()
                    .format(this.state.DateFormats.DateTimeFormat),
                '</span>'
            ].join('');
            let link = [
                '<span',
                'ng-if="!vm.state.linkFromName">',
                time,
                '</span><a ng-href=""',
                'class="pointer"',
                'uib-popover="View Trace Details"',
                'popover-animation',
                'popover-trigger="\'mouseenter\'"',
                'popover-placement="left"',
                'popover-append-to-body="true"',
                'ng-if="vm.state.linkFromName"',
                'ng-click="vm.caseTraceDetails(data)">',
                time,
                '</a>'
            ].join(' ');
            return link;
        };
        this.autoSizeAll = () => {
            let allColumnIds = [];
            if (this.columnDefs === undefined || this.columnDefs === null) {
                this.columnDefs = this.gridOptions.columnDefs;
            }
            this.columnDefs.forEach((columnDef) => {
                allColumnIds.push(columnDef.field);
            });
            this.gridOptions.columnApi.autoSizeColumns(allColumnIds);
        };
        this.getVerdictDetails = () => {
            let req = {
                TestId: this.state.selectedTest.Id,
                SimId: this.state.selectedSim.Id,
                TestSuiteId: this.state.selectedSuite.Id,
                Passed: this.state.selectedPassed,
                UserId: 0,
                Suspended: this.state.selectedSuspended
            };
            this.state.reportRequest = req;
            this.ReportServiceApi.getVerdictReportRows(req).then((response) => {
                let data = response.data;
                this.data.responseData = response.data;
                this.gridOptions.api.setRowData(data.TestResults);
                this.gridOptions.columnApi.setColumnVisible('Description', this.state.userDetails.IsAdmin || this.state.userDetails.IsSupport || this.state.userDetails.IsProjectTester);
                this.rowData = data;
            });
        };
        this.onModelUpdated = () => {
            let model = this.gridOptions.api.getModel();
            let processedRows = model.getRowCount();
            this.rowCount = processedRows.toLocaleString();
            this.autoSizeAll();
        };
        // Close the Summary Details Modal
        this.cancel = () => {
            this.dismiss();
        };
        this.caseTraceDetails = (row) => {
            let mode = { view: false, run: false };
            let selectedItems = {
                selectedTester: { Id: row.UserId, Name: row.Description },
                selectedSim: { Id: row.SimId, Name: row.SimName },
                selectedSuite: { Id: row.TestSuiteId, Name: row.TestSuiteName },
                selectedTest: { Id: row.TestId, Name: row.TestCaseName },
                unknownUser: { Id: 0, Name: 'Unknown' },
                fromTester: false
            };
            this.openDetails(selectedItems, mode);
        };
        this.openDetails = (selectedItems, mode) => {
            let tdParams = {
                selectedItems: selectedItems,
                mode: mode,
                user: this.state.userDetails,
                overTheShoulder: false
            };
            let modalInstance = this.uibModal.open({
                animation: true,
                size: 'xl',
                backdrop: 'static',
                keyboard: false,
                component: 'traceDetailsModal',
                resolve: {
                    params: () => {
                        return tdParams;
                    }
                }
            });
            // For debug
            // modalInstance.result.then(
            //     // close callback
            //     // console.log('trace-details closed')
            // );
        };
        this.routeParams = $routeParams;
        this.browser = $browser;
        this.window = $window;
        this.location = $location;
        this.uibModal = $uibModal;
        this.moment = moment;
        this.UserDetails = UserDetails;
        this.UserDetailsApi = UserDetailsApi;
        this.toastr = toastr;
        this.ReportService = ReportUtilityServiceApi;
        this.ReportServiceApi = ReportServiceApi;
        this.SettingsService = SettingsService;
    }
}
angular.module('app').component('verdictSummaryDetails', {
    templateUrl: 'scripts/app/partials/Reports/Verdict-Summary-Details.tpl.html',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    controllerAs: 'vm',
    controller: VerdictSummaryDetailsController
});
